import { LOGIN_TO_ISBYB, SET_KEYCLOAK, SET_KEYCLOAK_USER } from '../constants/ActionTypes'

import { axiosWithPostUrlEncoded as axios } from '../config/axios'
import { getAuthentication } from '../api/ispyb.js'
import qs from 'qs'
import { LOG_OUT } from 'constants/ActionTypes'
import JSEncrypt from 'jsencrypt'

export function doLogOut(user) {
  return { type: LOG_OUT, user }
}

export function setKeycloakUser(user) {
  return {
    type: SET_KEYCLOAK_USER,
    payload: user,
  }
}

export function setKeycloak(keycloak) {
  return {
    type: SET_KEYCLOAK,
    payload: keycloak,
  }
}

export const loginToIsbyb = (server, site, username) => dispatch => {
  let publicKey = getPublicKeyCredential();
//  console.log('getPublicKeyCredential');
//  console.log(getPublicKeyCredential);
  let usernameCipherRSABase64 = encryptRAS(username, publicKey);
  
//  console.log(usernameCipherRSABase64);
  const postData = {
    login: username,
    password: usernameCipherRSABase64,
  }
  dispatch({ type: LOGIN_TO_ISBYB, username: username, site: site, server: server })
  return axios.post(getAuthentication(server, site), qs.stringify(postData)).then(({ data }) => {
    if (data?.token) {
      return data
    }
    throw new Error('No token received')
  })
}

export const loginToIsbybToken = (server, site, token) => dispatch => {
  let publicKey = getPublicKeyCredential();
//  console.log('getPublicKeyCredential');
//  console.log(getPublicKeyCredential);
  let tokenCipherRSA = encryptRAS(token, publicKey);
  
//  console.log(tokenCipherRSA);
  const postData = {
    login: token,
    password: tokenCipherRSA,
  }
  dispatch({ type: LOGIN_TO_ISBYB, token: token, site: site, server: server })
  return axios.post(getAuthentication(server, site), qs.stringify(postData)).then(({ data }) => {
    if (data?.token) {
      return data
    }
    throw new Error('No token received')
  })
}

function encryptRAS (plaintext, publicKey) {
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    var messageCryptedRSA= encrypt.encrypt(plaintext);
    return messageCryptedRSA;
}

function getPublicKeyCredential () {
  let publicKey  = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGs2Zy/zs88t8KOzlAi4a3p58DLHscfqSbkjsaNV66wFgWKBTlx3ju/ox30QYQhB/oaYM9NQOW/vuQHrQH83CiypmMCe2vuhL7vpER66xB+D610I3oMs8t3SLrjY9bo1S7kgS0k/llqG2CPoD46DySP8DLRlU4RmW5S1VlmIllwwIDAQAB-----END PUBLIC KEY-----';
  return publicKey;
}
